<template>
  <draggable
    v-model="computedKeys"
    :move="checkMove"
    class="draggable-list-group"
    tag="ul"
    v-bind="dragOptions"
  >
    <transition-group :name="!drag ? 'flip-list' : null" type="transition">
      <li
        v-for="(item, i) in computedKeys"
        :key="item.name"
        class="draggable-group-item d-flex align-center"
      >
        <v-icon>mdi-drag-vertical</v-icon>

        <slot name="default" v-bind:item="item.name">
          <span>{{ item.name + " " + (i + 1) }}</span>
        </slot>
      </li>
    </transition-group>
  </draggable>
</template>

<script>
export default {
  name: "dragList",

  props: {
    value: Array,
  },

  data: () => ({
    drag: false,
  }),

  computed: {
    computedKeys: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },

  // watch: {
  //   computedKeys(val) {
  //     console.log('computedKeys: ', val)
  //   }
  // },

  methods: {
    checkMove(evt) {
      return evt.draggedContext.element.name !== "apple";
    },
  },
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.draggable-list-group {
  padding: 0;
  margin: 0;
  min-height: 20px;
  list-style: none;
}

.draggable-group-item {
  max-width: 100% !important;
  cursor: move;
}
</style>
